(function($, App, Utils, Components){
  'use strict';
  
  var logger = new Logger("Navigator");
  
  Components.create("Navigator", {
    
    Selectors: {
      Main: 'nav.main-nav',
      Submenu: '.submenu'
    },
    
    bindEvents: function() {
  
      Utils.Responsive.on(Utils.Responsive.Events.ResolutionEnter, function(e, res) {
        logger.info("Setting up %s navigator handlers", res.label);
        Components.Navigator.tearDown();
        Components.Navigator['setup' + res.label]();
      });
      
      Components.on('overlays:close', function(e) {
        App.Body.trigger('click.navigator');
      });
      
    },
    
    tearDown: function() {
      Components.Navigator.togglers.off('click.navigator');
      Components.Navigator.firstLevelTogglers.off('click.navigator');
    },
    
    setupxs: function() { Components.Navigator.setupHiRes() },
    setupsm: function() { Components.Navigator.setupHiRes() },
    setupmd: function() { Components.Navigator.setupHiRes()  },
    setuplg: function() { Components.Navigator.setupHiRes()  },
    
    // setupLowRes: function() {
    //   Components.Navigator.togglers.on('click.navigator', function(e) {
    //     logger.d("Toggle submenu");
    //     e.preventDefault();
    //
    //     var
    //       self = $(this),
    //       level = self.data('navigatorToLevel'),
    //       parent = self.closest('.level-' + (level - 1));
    //
    //     logger.d("Moving navigation to level %d", level);
    //     parent.removeClass('in').addClass('out');
    //     self.closest('li').find('.level-' + level).addClass('in');
    //   });
    //
    // },
    
    setupHiRes: function() {
      Components.Navigator.firstLevelTogglers.on('click.navigator', function(e) {
        logger.d("Toggle submenu");
        var
          self = $(this),
          parent = self.closest('li');
        
        if ( parent.is(':not(.active)') ) {
          e.preventDefault();
          e.stopPropagation();
          
          $('.menu > li').removeClass('active');
          
          parent.addClass('active');
          
          App.Body.on('click.navigator', function(e) {
            
            if ( $('.menu > li:hover').length != 0 ) {
              logger.d("Skip close because hovering");
              return;
            }
            
            Components.Navigator.nav.find('.menu > li').removeClass('active');
            App.Body.off('click.navigator');
          });
        } else {
          e.preventDefault();
          e.stopPropagation();
          parent.removeClass('active');
        }
      })
    },
    
    init: function() {
      Components.Navigator.nav = $(Components.Navigator.Selectors.Main);
      Components.Navigator.togglers = Components.Navigator.nav.find('.has-submenu');
      Components.Navigator.firstLevelTogglers = Components.Navigator.nav.find('.menu > li.has-submenu > a.nav-link');
      
      Components.Navigator.bindEvents();
  
      $(window).on('resize', function() {
        Components.Navigator.nav.find('.menu > li').removeClass('active');
      });
    }
    
  });
  
})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);
